export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40395f44d5979fa33a42ced8f5f69195135a3ee6e6&name=revalidateCommunity!'